import { Button } from '@progress/kendo-react-buttons';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { ExternalLinkOutline } from '../../../icons/icons';
import { LoadingIndicatorLinear } from '../../components/indicators/LoadingIndicatorLinear';
import { useAuthProvider } from '../../contexts/AuthProvider';
import { ROUTES } from '../../router/routes';
import { getRemoteAuthenticationUrl } from '../../../configs/env';
import { useIsAuthenticated } from '../../hooks/use-is-authenticated';

export function RemoteLogin() {
    const context = useAuthProvider();
    const isAuthenticated = useIsAuthenticated(context);
    const navigate = useNavigate();
    const [busy, setBusy] = useState(false);
    // Keep track of auto redirect. When we call logout account will change and that would've triggered auto-redirect instead of navigation to login page
    const autoRedirectCheckRun = useRef(false);

    useEffect(() => {
        if (autoRedirectCheckRun.current) {
            return;
        }

        autoRedirectCheckRun.current = true;
        if (!isAuthenticated) {
            setBusy(true);
            self.setTimeout(() => {
                window.location.href = getRemoteAuthenticationUrl();
            }, 1000);
        }
    }, [context, isAuthenticated]);

    const loginWithCommunityPortal = async () => {
        setBusy(true);
        if (context.account) {
            await context.instance.logout();
        }
        window.location.href = getRemoteAuthenticationUrl();
    };

    const handleLoginWithDifferentAccount = async () => {
        setBusy(true);
        if (context.account) {
            await context.instance.logout();
        }
        navigate(ROUTES.LOGIN, { replace: true });
    };

    const handleRemoteLoginConfirmAccount = () => {
        navigate(ROUTES.HOME, { replace: true });
    };

    return (
        <div>
            {busy && (
                <div className="mb-2">
                    <LoadingIndicatorLinear />
                </div>
            )}
            {context.initialized ? (
                context.account ? (
                    <div className="d-flex flex-column gap-3">
                        <div className="text-center">
                            <div className="mb-2 fw-bold" style={{ fontSize: '1rem' }}>
                                You are already signed in.
                            </div>
                            You're currently signed in to the Flight Explorer.
                            <br />
                            To continue to the app, tap the button below.
                        </div>
                        <div className="d-flex flex-column gap-2">
                            <Button themeColor={'primary'} style={{ textTransform: 'unset' }} onClick={handleRemoteLoginConfirmAccount}>
                                Continue as <strong>{context.account.userId}</strong>
                            </Button>
                            <Button
                                themeColor={'primary'}
                                fillMode={'outline'}
                                style={{ textTransform: 'unset' }}
                                svgIcon={ExternalLinkOutline}
                                onClick={loginWithCommunityPortal}>
                                Login with community portal
                            </Button>
                            <Button
                                fillMode={'outline'}
                                style={{ textTransform: 'unset' }}
                                onClick={handleLoginWithDifferentAccount}
                                themeColor={'primary'}>
                                Login with Flight Explorer account
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div>Redirecting to Community Portal...</div>
                )
            ) : (
                <>
                    <LoadingIndicatorLinear />
                    <div>Getting your account information...</div>
                </>
            )}
        </div>
    );
}
